import { MaritalStatus } from 'todistukset-common/src/vtj/MaritalStatus.enum'

export function maritalStatusBlocksAet(maritalStatus: MaritalStatus): boolean {
  return [
    MaritalStatus.AVIOLIITOSSA,
    MaritalStatus.REKISTEROIDYSSA_PARISUHTEESSA,
    // Unsure if we can still get ASUMUSEROSSA from VTJ, but it should count as blocking condition for AET.
    MaritalStatus.ASUMUSEROSSA,
  ].includes(maritalStatus)
}

export const aetAllowedMaritalStatuses = [
  MaritalStatus.NAIMATON,
  MaritalStatus.ERONNUT,
  MaritalStatus.LESKI,
] as const
